/**
 * Constants for measurement conversions
 */

// Conversion factors
export const CONVERSION_FACTORS = {
  CM_PER_INCH: 2.54,
  INCHES_PER_FOOT: 12,
  CM_PER_FOOT: 30.48,
  KG_TO_LBS: 2.20462,
  LBS_TO_KG: 0.453592,
} as const;

// Measurement bounds
export const MEASUREMENT_BOUNDS = {
  height: {
    min: 120, // cm
    max: 230, // cm
  },
  weight: {
    min: 30, // kg
    max: 200, // kg
  },
  bust: {
    min: 60, // cm
    max: 150, // cm
  },
  waist: {
    min: 50, // cm
    max: 120, // cm
  },
  hips: {
    min: 60, // cm
    max: 150, // cm
  },
} as const;

// Imperial specific bounds
export const IMPERIAL_BOUNDS = {
  inches: {
    min: 0,
    max: 11, // Maximum inches in a foot measurement
  },
  feet: {
    min: 3, // Minimum reasonable height in feet
    max: 8, // Maximum reasonable height in feet
  },
} as const;

// Storage keys
export const STORAGE_KEYS = {
  unitPreference: (type: string) => `measurement-unit-${type}`,
} as const;

// Precision settings
export const PRECISION = {
  weight: 1, // Number of decimal places for weight
  height: 0, // Number of decimal places for height
  measurements: 1, // Number of decimal places for body measurements
} as const;
